import { useContext, useEffect, useState } from "react";
import { getCoordinates } from "./house-service";
import { HouseCoordinatesApiProps } from "./types";
import { HouseCompetitionData } from "./contextProvider";
import Skeleton from "react-loading-skeleton";
import DOMPurify from "dompurify";

const HouseCoordinates = () => {
  const { prizeId } = useContext(HouseCompetitionData);
  const [isLoading, setIsLoading] = useState<boolean>(true);
  const [houseCoordinatesData, setHouseCoordinatesData] = useState<HouseCoordinatesApiProps>();
  let lat,
    long = "";
  if (houseCoordinatesData?.HouseCoordinatesData) {
    lat = houseCoordinatesData?.HouseCoordinatesData?.split(",")[0];
    long = houseCoordinatesData?.HouseCoordinatesData?.split(",")[1];
  }
  useEffect(() => {
    if (prizeId) {
      getHouseCoordinates();
    }
  }, [prizeId]);

  const getHouseCoordinates = async () => {
    try {
      const response = await getCoordinates(prizeId);
      const data = (await response.json()) as HouseCoordinatesApiProps;
      setHouseCoordinatesData(data);
    } catch (error) {
      console.error("Error fetching coordinates:", error);
    } finally {
      setIsLoading(false);
    }
  };

  return (
    houseCoordinatesData?.HouseCoordinatesData && (
      <div className="w-full h-[500px] flex flex-col gap-4">
        <h2 className="text-left font-jost text-[#28282B] text-[16px] font-medium normal-case">Where you'll be</h2>
        {isLoading ? (
          <Skeleton inline highlightColor="#fff" height={500} containerClassName="w-full bg-[#f1f1f1]" />
        ) : (
          <>
            <iframe
              title="Google Map"
              src={`https://www.google.com/maps?q=${lat},${long}&z=15&output=embed`}
              style={{ height: "100%", width: "100%" }}
              allowFullScreen
              loading="lazy"
              referrerPolicy="no-referrer-when-downgrade"
            />
            <div
              dangerouslySetInnerHTML={{
                __html: DOMPurify.sanitize(houseCoordinatesData?.HouseText),
              }}
            />
          </>
        )}
      </div>
    )
  );
};

export default HouseCoordinates;
